<script>
  import InvestorLayout from '../components/MenuList'
  import SectionFile from './components/SectionFile'
  import SectionInvestorContact from './components/SectionInvestorContact'
  import SectionStock from './components/SectionStock'

  export default {
    page() {
      return {
        title: `股東專欄 | 投資人專區`,
      }
    }, 
    components: {
      InvestorLayout,
      SectionFile,
      SectionInvestorContact,
      SectionStock
    },
    props: {
      defaultValue: {
        type: Object,
        default: () => {
        }
      },
      investorStock: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        stockList: []
      }
    },
    computed: {
      list() {
        return Object.keys(this.defaultValue)
          .map((category) => {
            const fileList = []
            this.defaultValue[category].forEach(({ files, title, year }) => {
              const fileItem = []
              files.forEach((item) => {
                fileItem.push({
                  ...item,
                  title: title,
                  year: year
                })
              })
              fileList.push(...fileItem)
            })
            // console.log(fileList)
            return {
              title: category,
              alias: category,
              items: fileList.map((file) => ({
                ...file,
                title: file.title,
                file: file.downloadLink
              }))
            }
          })
      }
    },
  }
</script>
<template>
  <InvestorLayout>
    <SectionStock 
      v-if="investorStock" 
      :investor-stock="investorStock"
    />
    <SectionFile :list="list"/>
    <SectionInvestorContact 
      v-if="investorStock && investorStock['investor-contact']" 
      :investor-contact="investorStock['investor-contact']"
    />
  </InvestorLayout>
</template>
<style lang="scss" module>

</style>
